import React from 'react';
import CrossIcon from '../../../../../../../../assets/Svg/CrossIcon';
import { GLOBAL_ASK_AICA_COPY } from '../../../../../../../../store/globalAskAica/constants';
import styles from './CompanyChip.module.scss';

interface CompanyChipProps {
    companyName: string;
    onClear: () => void;
}

/** "Answering for ‹Company›" — docked as a row above the composer (never a chat
 * bubble, per Figma). Hidden entirely when company-less (see AskAicaInputBox.tsx). */
const CompanyChip: React.FC<CompanyChipProps> = ({ companyName, onClear }) => (
    <div className={styles.CompanyChip} data-testid="company-chip">
        <span className={styles.ChipText}>
            {GLOBAL_ASK_AICA_COPY.CHIP_PREFIX} <strong>{companyName}</strong>
        </span>
        <button type="button" className={styles.ClearButton} onClick={onClear} aria-label="Clear company context">
            <CrossIcon colour="#1a1a1a" width="18" height="18" />
        </button>
    </div>
);

export default CompanyChip;
